<script>
import _ from 'lodash'
import L from 'leaflet'

export default {
  methods: {
    getZoomThreshold (path, map) {
      let zoomThreshold = null
      let zoom = map.getZoom()
      if (this.isCollapsed(path, zoom, map)) {
        while (!zoomThreshold) {
          zoom += 1
          if (!this.isCollapsed(path, zoom, map)) {
            zoomThreshold = zoom - 1
          }
        }
      } else {
        while (!zoomThreshold) {
          zoom -= 1
          if (this.isCollapsed(path, zoom, map)) {
            zoomThreshold = zoom
          }
        }
      }
      return zoomThreshold
    },

    isCollapsed (path, zoom, map) {
      const bounds = path.getBounds()

      const nePx = map.project(bounds.getNorthEast(), zoom)
      const swPx = map.project(bounds.getSouthWest(), zoom)

      const width = nePx.x - swPx.x
      const height = swPx.y - nePx.y
      return (height < 13 || width < 13)
    },

    layerAdd (feature, featureGroup, removedFeatures, map) {
      if (!feature._layers && feature.getBounds && !feature.zoomThreshold && !feature.marker) { // eslint-disable-line
        const zoomThreshold = this.getZoomThreshold(feature, map)
        const marker = L.marker(feature.getBounds().getCenter())

        if (feature._popupHandlersAdded) { // eslint-disable-line
          marker.bindPopup(feature._popup._content); // eslint-disable-line
        }

        const events = feature._events; // eslint-disable-line
        for (const event in events) { // eslint-disable-line
          if (events.hasOwnProperty(event)) { // eslint-disable-line
            const listeners = events[event]
            for (let i = 0, len = listeners.length; i < len; i++) {
              marker.on(event, listeners[i].fn)
            }
          }
        }
        feature.zoomThreshold = zoomThreshold; // eslint-disable-line
        feature.marker = marker; // eslint-disable-line

        if (map.getZoom() <= zoomThreshold) {
          featureGroup.removeLayer(feature)
          featureGroup.addLayer(feature.marker)
          removedFeatures.addLayer(feature)
        }
      }
    },

    removeLayer (layer, featureGroup, removedFeatures) {
      const feature = (layer instanceof L.Marker)
        ? _.find(removedFeatures.getLayers(), feature => feature.marker === layer) || layer : layer

      featureGroup.removeLayer(feature.marker)
      featureGroup.removeLayer(feature)
      removedFeatures.removeLayer(feature)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/AppDeflate.vue